/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_ScheduleInputs */

const vi_shop_home_schedule = /** @type {(inputs: Shop_Home_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch hiện`)
};

/**

* @param {Shop_Home_ScheduleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_schedule = /** @type {((inputs?: Shop_Home_ScheduleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_ScheduleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_schedule(inputs)
});